import React from "react";
import {Button, Input} from "reactstrap";
import {IExoReplacerBody} from "../../../../store/exo/types";

interface ExoReplacerRowProps {
    replacement: IExoReplacerBody;
    readOnly?: boolean;
    autoFocus?: boolean;
    disabled?: boolean;
    focusRef?: React.Ref<HTMLInputElement>;
    onChange?: (replacer: IExoReplacerBody) => void;
    onRemove?: () => void;
}

const ExoReplacerRow: React.FC<ExoReplacerRowProps> = ({
                                                           replacement,
                                                           readOnly = false,
                                                           autoFocus = false,
                                                           disabled = false,
                                                           focusRef,
                                                           onChange,
                                                           onRemove
                                                       }) => {
    return (
        <div className="d-flex gap-2 align-items-center mb-2">
            <div className="flex-grow-1">
                <Input
                    innerRef={focusRef}
                    placeholder="From *"
                    value={replacement.from}
                    disabled={readOnly || disabled}
                    autoFocus={autoFocus}
                    onChange={e => onChange?.({...replacement, from: e.target.value})}/>
            </div>

            <i className="mdi mdi-arrow-right font-size-16"></i>

            <div className="flex-grow-1">
                <Input
                    placeholder="To *"
                    value={replacement.to}
                    disabled={readOnly || disabled}
                    onChange={e => onChange?.({...replacement, to: e.target.value})}/>
            </div>

            {!readOnly && <Button
                color="link"
                type="button"
                className="text-danger p-0"
                title="Remove replacer"
                onClick={onRemove}
                disabled={disabled}
            >
                <i className="mdi mdi-delete font-size-18"></i>
            </Button>}
        </div>
    );
};

export default ExoReplacerRow;